module.exports = __webpack_public_path__ + "static/media/settlementBtn.c06ffbeb.png";